<template>
  <div>
    <v-container grid-list-md class="relatorios-historico-container">
      <v-layout row wrap class="equal-heights pa-5 historico-layout">
        <v-flex xs12 sm10 offset-sm1 v-if="por === 'data'">
          <ul class="opcoes">
            <li :class="{ 'ativo': periodoSelecionado === 'recentes' }" @click="changePeriodo('recentes')">
              <strong>mais recentes</strong>
            </li>
            <li :class="{ 'ativo': periodoSelecionado === 'dia' }" @click="changePeriodo('dia')">
              <strong>dia</strong>
            </li>
            <li :class="{ 'ativo': periodoSelecionado === 'semana' }" @click="changePeriodo('semana')">
              <strong>semana</strong>
            </li>
            <li :class="{ 'ativo': periodoSelecionado === 'mes' }" @click="changePeriodo('mes')">
              <strong>mês</strong>
            </li>
            <li :class="{ 'ativo': periodoSelecionado === 'semestre' }" @click="changePeriodo('semestre')">
              <strong>semestre</strong>
            </li>
            <li :class="{ 'ativo': periodoSelecionado === 'ano' }" @click="changePeriodo('ano')">
              <strong>ano</strong>
            </li>
            <li :class="{ 'ativo': periodoSelecionado === 'custom' }">
              <v-menu full-width offset-y :close-on-content-click="false" v-model="dateMenu" bottom>
                <strong slot="activator">por período</strong>
                <v-card>
                  <v-card-text>
                    <DateRange :options="dateRangeOptions" no-presets @input="onDateRangeChange"></DateRange>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat class="primary--text" @click.native="changePeriodoCustom">Aplicar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 sm10 offset-sm1 v-else>
          <ul class="opcoes">
            <li v-for="user in users" :class="{ 'ativo': userSelecionado === user.id }" @click="changeUserSelecionado(user.id)">
              <strong>{{ user.name }}</strong>
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 sm10 offset-sm1>
          <v-card class="mx-3 px-4 py-3 historico-card" style="min-height: 70vh;">
            <v-card-text v-if="paginacao.total > 0">
              <div v-for="(dia, index) in historico" class="alteracao">
                <p class="data alteracao-data">{{ formatData(index) }}</p>
                <div v-for="alteracoes in dia" class="alteracao-imovel">
                  <div class="alteracao-imovel-apelido">
                    <strong v-if="alteracoes[0]['apelido']">{{ alteracoes[0]['apelido'] }}</strong>
                    <template v-if="alteracoes[0]['endereco']">
                      &nbsp;&nbsp;&nbsp;{{ formatEndereco(alteracoes[0]['endereco']) }}
                    </template>
                  </div>
                  <div v-for="alteracao in alteracoes" class="alteracao-tipo">
                    <template v-if="alteracao['event'] === 'created'">
                      <template v-if="formatType(alteracao['auditable_type']) === 'Imóvel'">
                        <span class="data">Imóvel criado às {{ formatHora(alteracao['created_at']) }} por <em>{{ alteracao['user']['name'] }}</em></span>
                      </template>
                      <template v-else>
                        <span class="data">Criação de {{ formatType(alteracao['auditable_type']) }} às {{ formatHora(alteracao['created_at']) }} por <em>{{ alteracao['user']['name'] }}</em></span>
                        <div v-for="(new_value, new_value_index) in alteracao['new_values']" v-if="new_value !== '' && new_value !== null">
                          {{ formatColunaName(new_value_index) }}:
                          <strong class="valor-novo">{{ formatValue(alteracao['new_values'][new_value_index], new_value_index) }}</strong>
                        </div>
                      </template>
                    </template>
                    <template v-if="alteracao['event'] === 'deleted'">
                      <template v-if="formatType(alteracao['auditable_type']) === 'Imóvel'">
                        <span class="data">Imóvel removido às {{ formatHora(alteracao['created_at']) }} por <em>{{ alteracao['user']['name'] }}</em></span>
                      </template>
                      <template v-else>
                        <span class="data">Remoção de {{ formatType(alteracao['auditable_type']) }} às {{ formatHora(alteracao['created_at']) }} por <em>{{ alteracao['user']['name'] }}</em></span>
                        <div v-for="(old_value, old_value_index) in alteracao['old_values']">
                          {{ formatColunaName(old_value_index) }}:
                          <strong class="valor-antigo">{{ formatValue(old_value, old_value_index) }}</strong>
                        </div>
                      </template>
                    </template>
                    <template v-else-if="alteracao['event'] === 'updated'">
                      <span class="data">Alteração de {{ formatType(alteracao['auditable_type']) }} às {{ formatHora(alteracao['created_at']) }} por <em>{{ alteracao['user']['name'] }}</em></span>
                      <div v-for="(old_value, old_value_index) in alteracao['old_values']">
                        {{ formatColunaName(old_value_index) }}:
                        <strong class="valor-novo">{{ formatValue(alteracao['new_values'][old_value_index], old_value_index) }}</strong>
                        <span v-if="alteracao['new_values'][old_value_index] !== '' && alteracao['new_values'][old_value_index] !== null && old_value !== '' && old_value !== null">&nbsp;|&nbsp;</span>
                        <strong class="valor-antigo">{{ formatValue(old_value, old_value_index) }}</strong>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="secondary--text text-xs-center subheading my-5" v-if="paginacao !== undefined && paginacao.current_page < paginacao.total_pages">
                <span @click="loadHistorico(paginacao.current_page + 1)" style="cursor: pointer;">CARREGAR MAIS</span>
              </div>
            </v-card-text>
            <v-card-text v-else>
              <div class="subheading text-xs-center pt-5">Nenhum resultado encontrado. Experimente remover os filtros de imóveis.</div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  import _ from 'lodash'
  import moment from 'moment'
  import currencyFormatter from 'currency-formatter'
  import DateRange from 'vuetify-daterange-picker'
  import 'vuetify-daterange-picker/dist/vuetify-daterange-picker.css'

  export default {
    components: { DateRange },
    data () {
      return {
        unsubscribe: null,
        dateRangeOptions: {
          minDate: '2018-01-01',
          startDate: moment().startOf('day').subtract('1', 'months').format('YYYY-MM-DD'),
          endDate: moment().startOf('day').format('YYYY-MM-DD'),
          format: 'DD/MM/YYYY'
        },
        dateMenu: false,
        periodoSelecionado: 'recentes',
        dataInicial: moment().startOf('day').subtract('1', 'months').format('YYYY-MM-DD'),
        dataFinal: moment().startOf('day').format('YYYY-MM-DD'),
        userSelecionado: null
      }
    },
    mounted () {
      this.$store.dispatch('users/loadUsers')

      if (this.por === 'data') {
        this.clearHistorico()
        this.loadHistorico()
      }

      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'imoveis/SET_FILTROS') {
          this.clearHistorico()
          this.loadHistorico()
        }
      })
    },
    beforeDestroy () {
      this.unsubscribe()
    },
    computed: {
      por () {
        return (this.$route.name === 'RelatoriosHistoricoData') ? 'data' : 'usuário'
      },
      users () {
        return this.$store.getters['users/users']
      },
      historico () {
        let historicoFormatado = {}
        _.forEach(this.$store.getters['relatorios/historico'], (item, key) => {
          const dataFormatada = _.groupBy(item, (imovel) => {
            return 'imovel' + imovel.tags
          })
          historicoFormatado[key] = dataFormatada
        })
        return historicoFormatado
      },
      paginacao () {
        return this.$store.getters['relatorios/historicoPaginacao']
      },
      filtros () {
        return this.$store.getters['imoveis/filtros']
      }
    },
    methods: {
      formatType (type) {
        const typeName = type.split('\\').pop()
        const fixTypeNames = {
          'Imovel': 'Imóvel',
          'Area': 'Área',
          'Endereco': 'Endereço',
          'Observacao': 'Observação'
        }

        if (fixTypeNames.hasOwnProperty(typeName)) {
          return fixTypeNames[typeName]
        } else {
          return typeName
        }
      },
      formatEndereco (endereco) {
        return _.filter([`${endereco['tipo']} ${endereco['logradouro']}`, endereco['numero'], endereco['complemento']]).join(', ')
      },
      formatData (data) {
        return moment(data).format('DD/MM/YYYY')
      },
      formatHora (hora) {
        return moment(hora).format('H:mm')
      },
      formatColunaName (coluna) {
        const fixColunaNames = {
          'titulo': 'Título',
          'conteudo': 'Conteúdo',
          'area_terreno': 'Área do terreno',
          'area_construida': 'Área construída',
          'area_util': 'Área útil',
          'calcada': 'Calçada',
          'numero': 'Número',
          'cep': 'CEP',
          'uf': 'UF',
          'loteamento': 'Loteamento',
          'loteamento_nome': 'Nome do loteamento',
          'loteamento_lote': 'Número no loteamento',
          'loteamento_quadra': 'Quadra no loteamento',
          'coordenadas_manual': 'Coordenadas manuais',
          'proprietario': 'Proprietário',
          'matricula': 'Matrícula',
          'transcricao': 'Transcrição',
          'cartorio': 'Cartório',
          'vago_com_placa': 'Vago - Com placa',
          'vago_seguranca': 'Vago - Segurança',
          'vago_seguranca_observacoes': 'Vago - Segurança (observações)',
          'compromissado_condicao': 'Compromissado - Condição',
          'compromissado_comprador': 'Compromissado - Comprador',
          'compromissado_data': 'Compromissado - Data do compromisso',
          'compromissado_inadimplente_data': 'Compromissado - Data da inadimplência',
          'compromissado_ajuizado_cliente': 'Compromissado - Nº do cliente/caso',
          'compromissado_ajuizado_processo': 'Compromissado - Nº do processo/execução',
          'locado_condicao': 'Locado - Condição',
          'locado_locador': 'Locado - Nome do locador',
          'locado_locatario': 'Locado - Nome do locatário',
          'locado_valor': 'Locado - Valor do aluguel',
          'locado_valor_data': 'Locado - Data do valor do aluguel',
          'locado_inicio_data': 'Locado - Data do início do contrato',
          'locado_fim_data': 'Locado - Data do fim do contrato',
          'locado_acao_renovatoria': 'Locado - Ação renovatória',
          'locado_acao_renovatoria_numero': 'Locado - Ação renovatória- Nº da ação',
          'locado_acao_renovatoria_cliente': 'Locado - Ação renovatória - Nº do cliente/caso',
          'locado_inadimplente_data': 'Locado - Data da inadimplência',
          'locado_ajuizado_cliente': 'Locado - Nº do cliente/caso',
          'locado_ajuizado_processo': 'Locado - Nº do processo/execução',
          'comodato_nome': 'Comodato - Nome',
          'comodato_rg': 'Comodato - RG',
          'comodato_cpf': 'Comodato - CPF',
          'comodato_telefone': 'Comodato - Telefone',
          'invadido_condicao': 'Invadido - Condição',
          'invadido_nome': 'Invadido - Nome',
          'invadido_rg': 'Invadido - RG',
          'invadido_cpf': 'Invadido - CPF',
          'invadido_telefone': 'Invadido - Telefone',
          'invadido_data': 'Invadido - Data estimada da invasão',
          'invadido_ajuizado_cliente': 'Invadido - Nº do cliente/caso',
          'invadido_ajuizado_processo': 'Invadido - Nº do processo/execução',
          'situacao': 'Situação',
          'ajuizado_cliente': 'Nº do cliente/caso',
          'ajuizado_processo': 'Nº do processo/execução',
          'estimativa_valor': 'Estimativa do valor do imóvel',
          'estimativa_data': 'Data da estimativa do valor do imóvel',
          'regiao_valor': 'Valor do m² da região',
          'observacoes': 'Observações',
          'recorrencia': 'Recorrente',
          'recorrencia_cada': 'Recorrência a cada',
          'recorrencia_periodo': 'Recorrência período',
          'realizada': 'Realizada',
          'realizada_em': 'Realizada em'
        }

        if (fixColunaNames.hasOwnProperty(coluna)) {
          return fixColunaNames[coluna]
        } else {
          return _.startCase(_.toLower(coluna))
        }
      },
      formatValue (value, coluna) {
        const data = [
          'compromissado_data',
          'compromissado_inadimplente_data',
          'locado_valor_data',
          'locado_inicio_data',
          'locado_fim_data',
          'locado_inadimplente_data',
          'invadido_data',
          'estimativa_data',
          'realizada_em',
          'data'
        ]

        const valor = [
          'locado_valor',
          'estimativa_valor',
          'regiao_valor'
        ]

        const area = [
          'area_terreno',
          'area_construida',
          'area_util'
        ]

        const boolean = [
          'calcada',
          'muro',
          'loteamento',
          'coordenadas_manual',
          'vago_com_placa',
          'locado_acao_renovatoria',
          'realizada',
          'recorrencia',
          'postergarda'
        ]

        const telefone = [
          'comodato_telefone',
          'invadido_telefone'
        ]

        if (value === null) {
          return null
        }

        if (data.indexOf(coluna) > -1) {
          return moment(value).format('DD/MM/YYYY')
        }

        if (valor.indexOf(coluna) > -1) {
          return currencyFormatter.format(value, { code: 'BRL' })
        }

        if (area.indexOf(coluna) > -1) {
          return value + 'm²'
        }

        if (boolean.indexOf(coluna) > -1) {
          if (value) {
            return 'Sim'
          } else {
            return 'Não'
          }
        }

        if (telefone.indexOf(coluna) > -1) {
          return _.map(JSON.parse(value), 'numero').join(', ')
        }

        if (coluna === 'tipo') {
          return this.formatType(_.startCase(_.toLower(value)))
        }

        if (coluna === 'recorrencia_periodo') {
          return _.startCase(_.toLower(value))
        }

        if (value === true) {
          return 'Sim'
        }

        if (value === false) {
          return 'Não'
        }

        return value
      },
      clearHistorico () {
        this.$store.dispatch('relatorios/clearHistorico')
      },
      loadHistorico (page) {
        const payload = {}

        if (!_.isEmpty(this.filtros)) {
          Object.assign(payload, this.filtros)
        }

        payload.periodo = this.periodoSelecionado

        if (this.periodoSelecionado === 'custom') {
          payload.data_inicial = this.dataInicial
          payload.data_final = this.dataFinal
        }

        if (this.por === 'usuário') {
          payload.user_id = this.userSelecionado
        }

        if (page) {
          payload.page = page
        }

        this.$store.dispatch('relatorios/loadHistorico', payload)
      },
      onDateRangeChange (data) {
        this.dataInicial = data[0]
        this.dataFinal = data[1]

        if (this.periodoSelecionado === 'custom') {
          this.clearHistorico()
          this.loadHistorico()
        }
      },
      changePeriodo (periodo) {
        this.periodoSelecionado = periodo

        this.clearHistorico()
        this.loadHistorico()
      },
      changePeriodoCustom () {
        this.periodoSelecionado = 'custom'
        this.clearHistorico()
        this.loadHistorico()
        this.dateMenu = false
      },
      changeUserSelecionado (id) {
        this.userSelecionado = id
      }
    },
    watch: {
      por () {
        this.clearHistorico()
        this.loadHistorico()
      },
      users () {
        this.userSelecionado = this.users[0].id
      },
      userSelecionado () {
        if (this.por === 'usuário') {
          this.clearHistorico()
          this.loadHistorico()
        }
      }
    }
  }
</script>

<style scoped>
.alteracao { float: left; width: 100%; }

.alteracao-tipo { margin-bottom: 10px; float: left; width: 100%; }

.alteracao-imovel { margin: 0 0 40px 22px; float: left; width: 100%; }

.alteracao-imovel-apelido { margin-bottom: 10px; font-size: 15px; }

.alteracao-data, .alteracao-autor { font-size: 13px; }
.alteracao-data { margin: 16px 0 20px 0; }

.valor-novo { color: #4FBF46; }
.valor-antigo { color: #ED1B09; }

.opcoes { color: #7D7D7D; font-size: 12px; list-style: none; margin-left: 18px; padding-left: 0; margin-bottom: 10px; }
.opcoes li { margin-right: 24px; display: inline-block; cursor: pointer; }
.opcoes li.ativo { color: #FF7715; }

@media (max-width: 959px) {
  .relatorios-historico-container.container {
    max-width: 100% !important;
    width: 100% !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .historico-layout {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 12px !important;
  }

  .historico-layout > .flex {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .opcoes {
    margin-left: 0;
  }

  .opcoes li {
    margin-right: 12px;
    margin-bottom: 8px;
  }

  .historico-card {
    margin-left: 0 !important;
    margin-right: 0 !important;
    border-radius: 0;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  .alteracao-imovel {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// RelatoriosHistorico.vue?8c6ef06e